import type { Address } from 'viem';
import type { EncodedTx } from '../types.js';
import type { SignerStrategy } from './index.js';

/**
 * Self signer — the private key belongs to the trader directly.
 * Transactions are submitted as-is without any delegation wrapping.
 *
 * In Self + Self mode:  traderAddress = EOA derived from privateKey.
 * In Self + Gasless mode: NOT used — that mode uses DelegatedSignerStrategy
 *                         because the EOA is the trader and the Safe is the delegate.
 */
export class SelfSignerStrategy implements SignerStrategy {
  readonly traderAddress: Address;

  constructor(traderAddress: Address) {
    this.traderAddress = traderAddress;
  }

  prepare(encoded: EncodedTx): EncodedTx {
    return encoded;
  }
}
